import { Switch as HeadlessSwitch } from '@headlessui/react';
import React, { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';

import { ToggleLockIcon } from 'assets/icons/library/ToggleLockIcon';

export interface ToggleProps {
  className?: string;
  style?: CSSProperties;
  onClick: () => void;
  state: 'default' | 'checked' | 'locked' | 'disabled';
  checkedBackgroundColor?: string;
  size?: 'small' | 'medium';
}

export const Toggle: React.FC<ToggleProps> = ({ onClick, className, style, state, checkedBackgroundColor, size = 'medium' }) => {
  const disabled = state === 'disabled' || state === 'locked';
  const isChecked = state === 'checked';
  const isLocked = state === 'locked';

  return (
    <HeadlessSwitch checked={isChecked ?? false} disabled={disabled} onChange={onClick} style={style} className={className}>
      <span
        className={twMerge(
          'h-6 w-10 rounded-full flex p-spl-1 bg-bg-tert-10-80 transition-all',
          size === 'small' && 'w-8 h-5',
          isChecked && (checkedBackgroundColor ?? 'bg-bg-prim-cta'),
          'outline-none focus:ring-transparent focus:ring-offset-0 focus:ring-0',
          'focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-bg-prim-w-b focus-visible:ring-[#1D76ED]'
        )}
      >
        <span
          className={twMerge(
            'h-5 w-5 block relative transition rounded-full duration-300 ease-in-out transform bg-icn-txt-white',
            size === 'small' && 'size-4',
            isChecked && (size === 'medium' ? 'translate-x-[80%]' : 'translate-x-[75%]'),
            disabled && 'bg-icn-txt-tert'
          )}
        >
          {isLocked && <ToggleLockIcon />}
        </span>
      </span>
    </HeadlessSwitch>
  );
};
